export default "__VITE_ASSET__DaaSj3UR__"